import React, { useEffect } from 'react'
import { useController } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { MultiSelectCombobox } from '../../../../legacy-design-system/combobox'
import { Box } from '../../../../legacy-design-system/form'
import { useServerlessAccountsQuery } from '../api/use-serverless-accounts-query'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { useJiraIntegrationPage } from './jira-integration-page.provider'

export const ServerlessAccountsField = () => {
  const { formatMessage } = useIntl()

  const {
    state: { organizationUuid }
  } = useJiraIntegrationPage()

  const { accounts } = useServerlessAccountsQuery({
    organizationUuid
  })

  const {
    field: { onChange, value }
  } = useController({ name: JiraFormFieldTypes.SERVERLESS_ACCOUNT_IDS })

  useEffect(() => {
    if (typeof value?.[0] === 'string' && accounts) {
      onChange(
        value.map((val) =>
          accounts.find((account) => account.accountId === val)
        )
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts])

  return (
    <Box basis={10}>
      <MultiSelectCombobox
        values={value || []}
        label={formatMessage({
          id: 'title_integrationsSettings_serverlessAccounts'
        })}
        placeHolderTag={formatMessage(
          { id: 'variable_allAccounts' },
          { count: accounts?.length || 0 }
        )}
        items={[
          {
            items: accounts || []
          }
        ]}
        itemToString={(item) => `${item?.name} (${item?.accountId})`}
        onChange={onChange}
        data-testid="serverless-accounts-multi-select"
      />
    </Box>
  )
}
